import { render, staticRenderFns } from "./laberName.vue?vue&type=template&id=dfd6a2bc&scoped=true&"
import script from "./laberName.vue?vue&type=script&lang=js&"
export * from "./laberName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd6a2bc",
  null
  
)

export default component.exports